import axios from 'axios'
import Utils from '@/common/utils'

const url = `${process.env.VUE_APP_BASE_API}/api`
const headers = { Authorization: Utils.setLocalToken() }

export default class SATService {
  static async validateCredentials (payload) {
    try {
      const { data } = await axios.post(`${url}/validateCredentials/`, payload, { headers })
      return data
    } catch (error) {
      throw error.response
    }
  }

  static async updateCredentials (payload) {
    try {
      const { data } = await axios.put(`${url}/clientCredentials/`, payload, { headers })
      return data
    } catch (error) {
      throw error.response
    }
  }

  static async SatSync (payload) {
    try {
      const { data } = await axios.post(`${url}/satsync/`, payload, { headers })
      return data
    } catch (error) {
      throw error.response
    }
  }

  static async syncInvoices ({ clientId }) {
    try {
      const { data } = await axios.post(`${url}/sync/${clientId}`, {}, { headers })
      return data
    } catch (error) {
      throw error.response
    }
  }
}
